import React, { Component } from 'react';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import { withNamespaces } from 'react-i18next';
import LoadingOverlay from 'react-loading-overlay'
import BeatLoader from 'react-spinners/BeatLoader'
import i18next from 'i18next';

import PayBankBalance from './PayBankBalance';
import { resizeComponent } from '../../../utils';
import styles from '../../../styles/bankBalance.module.css';

class PayBankContainer extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        resizeComponent('div[data-id=headerBankBalance]', '#divPayBankContainer', '#appBarTitle', 100);
    }

    render() {
        return (
            <LoadingOverlay
                spinner={<BeatLoader />}
                text={i18next.t('bankBalance:form.loading')}
            >
                <div id="divPayBankContainer" className={styles.rootBankBalance} style={{ marginTop: '20px'}}>
                    <AccordionDetails>
                        <PayBankBalance isFromBankBalanceMenu={true} />
                    </AccordionDetails>
                </div>
            </LoadingOverlay>
        )
    }
}

export default withNamespaces(['bankBalance'], { wait: true })((PayBankContainer));